import { render } from "./TronHeader.vue?vue&type=template&id=8a007970&scoped=true"
import script from "./TronHeader.vue?vue&type=script&lang=js"
export * from "./TronHeader.vue?vue&type=script&lang=js"

import "./TronHeader.vue?vue&type=style&index=0&id=8a007970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a007970"]])

export default __exports__